<template>
<div>


<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
<h4 >CLASSIFICAZIONE - <strong style="color:red">GIGLIO.COM</strong></h4>

<div class="form-group">
    <label  for="brand"><strong>Brand</strong></label>
     <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    <select  @change="setData()" id="brand" name="brand" class="form-control" v-model="product.brandId">
        <option v-for="(item,index) in brands" :value="item.ID" :key="index">{{item.description}}</option>        
    </select>     
</div> 

<div class="form-group">
    <label  for="categoria"><strong>Categoria</strong></label>
    <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    <select  @change="setData()" id="category" name="category" class="form-control" v-model="product.categoryId">
        <option v-for="(item,index) in categories" :value="item.ID" :key="index">{{item.description}}</option>        
    </select> 
    
</div> 

<table class="table table-sm"  id="productSupplierColor">
    <thead class="_thead-light">
      <tr>
        
        <th>
           Colore ID 
        </th>
        <th>
           Colore gestionale 
        </th>
        <th>
           Colore fornitore
        </th>
        
        <th>
           Colore GIGLIO
        </th>
        
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item,index) in items" :key="index">
        <td style="color: blue" >
          <strong>{{item.colorId}}</strong>
        </td>  
        
        <td style="color: blue" >
          <strong>{{item.color}}</strong>
        </td>  
        <td style="color: blue" >
          <strong>{{item.supplier_color}}</strong>
        </td>  
        
        <td >
        
            <!--<input v-model = "item.supplierColor" class="form-control bold"  v-bind:id="'id_' + index " type="text">-->
            
    <select  id="color"  class="form-control" v-model="colorId[index]">
        <option v-for="(item,index) in colors" :value="item.ID" :key="index">{{item.description}}</option>        
    </select> 
        </td>

      </tr>
    </tbody>
  </table>
  
  <button  type="button" @click="UpdateGiglioProduct()"  class="btn btn-primary  mt-2 mr-1">
       <i class="fas fa-save mr-2" aria-hidden="true"></i>
       SALVA
       <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
</button> 
<button  type="button" @click="$emit('close')"  class="btn btn-outline-secondary  mt-2 ml-1 ">
       <i class="far fa-window-close mr-2" aria-hidden="true"></i>
       CHIUDI        
</button> 





</div>

</template>

<script>

import { mapGetters } from 'vuex';


import alertBox       from '@/components/common/AlertBox.vue'
import api            from '@/api'
import axios          from "axios"
  export default {
  props : ['productId'],

     components: {alertBox},
    data () {
      return {
        
        api   : { 'brands'     : 'https://api.giglio.com/public/stylists',
                  'categories' : 'https://api.giglio.com/public/categories',
                  'colors'     : 'https://api.giglio.com/public/colors'},     
        brands       : [],         
        categories   : [],        
        colors       : [],
        items        : [],
        product      : {},       
        colorId      : [],        
        msg             : {title : '',body:'',type :0},
        
        spinner      : false,
        bt_spinner   : false
       

      }
    },

    
  
    computed: {
     ...mapGetters(['company']),

     
      
      
    },
    created () 
      {
    
        
        this.product.brandId = JSON.parse(localStorage.getItem("giglio_brandId"))
        this.product.categoryId = JSON.parse(localStorage.getItem("giglio_categoryId"))

        this.getData()
        
      },
    methods: 
    {
      
    setData()
    {      
      localStorage.setItem('giglio_brandId',JSON.stringify(this.product.brandId))
      localStorage.setItem('giglio_categoryId',JSON.stringify(this.product.categoryId))
    },

    async getGiglioProduct()
    {
    
    this.spinner  = true
        
    var data      = {'productId' : this.productId}
    var sp        = {'sp' : 'spGiglioProduct'}
    var json      = Object.assign(data, sp);
    await api.post(json).then(res => {
          
          if(res.status==200)
            {
              if(res.data.recordsets[0].length > 0) 
              {
                this.product = res.data.recordsets[0][0]
              }  

              this.items = res.data.recordsets[1]
              this.items.forEach(item=>{
                  this.colorId.push(item.ID)
              })

            }
           else if(res.status==500)
           {
                
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type  = 1
                              
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
                
              
          }).finally(() => {
          this.spinner = false
        });
  
    
    },   

  
      async getData()
      { 
          this.spinner = true
          axios.all([
            axios.get(this.api.brands),
            axios.get(this.api.categories),
            axios.get(this.api.colors)
            ])
            .then(responseArr => {
           
            //this will be executed only when all requests are complete
           
            this.brands = responseArr[0].data
            this.categories = responseArr[1].data
            this.colors = responseArr[2].data
            this.getGiglioProduct()  


        }).finally(() => {
          this.spinner = false
        })
                
      },


    async UpdateGiglioProduct()
    {
    
    let colors = []
    let index = 0
    let err = false
    this.items.forEach(item=>{

         colors.push({

            'colorId':item.colorId,'ID':this.colorId[index]

        })

        if(!this.colorId[index])
        {
          err = true
        }

        index++
    })  


    this.msg.title = ''
    if(!this.product.brandId || !this.product.categoryId || err)  
    {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Classificazione non completa.'
        this.msg.type  = 1
        return
    }

    this.bt_spinner  = true
    
    var data      = {'productId' : this.productId,'brandId':this.product.brandId,'categoryId':this.product.categoryId,'body':colors}
    var sp        = {'sp' : 'spUpdateGiglioProduct'}

    var json      = Object.assign(data, sp);
    await api.post(json).then(res => {
          
          if(res.status==200)
            {
              //this.$emit('close')
              this.msg.title = 'Classificazione GIGLIO.'
              this.msg.body = 'Classificazione effettuata.'
              this.msg.type  = 0

            }
           else if(res.status==500)
           {
                
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                
                
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type  = 1
                              
                 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
                
              
          }).finally(() => {
          this.bt_spinner = false
        });
  
    
    },   
    

      
      

    }
  }
</script>
<style scoped>

p {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}

.selected
{
  color        : red;  
  font-family  : 'Roboto Condensed';
  font-weight  : bold;
  
  
}
.green{
  background-color: #41B883;
}

tr {
    cursor: pointer;
} 
.pointer:hover
{
  _background-color: blue;
  _color: white;
  cursor: pointer;
}
 
  .my-custom-scrollbar {
    position  : relative;
    height    : 200px;
    overflow  : auto;
    }
  .table-wrapper-scroll-y {
    display   : block;
  }

  .table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : white;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

</style>
